/** Valor em reais no formato pt-BR (R$ 59,90). Usado no catálogo e no faturamento. */
export const reais = (valor: number | null | undefined): string =>
  valor == null ? '—' : valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
